import React from 'react';

import { PlanChooser, WikiWrapper } from 'apps/components';
import { BackButton } from 'components';
import { StartFreeTrail } from 'constants/subscription';
import { clientStore } from 'apps/client/app';

interface ChoosePlanProps {
  onClickCompanyForTeam: () => void;
  onClickCompanyForBusiness: () => void;
}

export const ChoosePlan = ({
  onClickCompanyForTeam,
  onClickCompanyForBusiness,
}: ChoosePlanProps) => {
  return (
    <WikiWrapper
      hiddenLogo={clientStore.signedInProfile}
      headerRight={
        <BackButton
          className='relative right-4 text-black text-lg'
          onClick={() => {
            history.back();
          }}
        />
      }
    >
      <PlanChooser
        hideSwitcher={true}
        teamChooseText={StartFreeTrail}
        businessChooseText={StartFreeTrail}
        onClickCompanyForTeam={() => {
          onClickCompanyForTeam();
        }}
        onClickCompanyForBusiness={() => {
          onClickCompanyForBusiness();
        }}
      />
    </WikiWrapper>
  );
};
